import $ from 'jquery';
import 'jscroll';

import { LoadingIndicator } from './components/jscroll-spin';

export default class BehindTheScenesHomePage {
    constructor(options) {
        this.$el = $(options.el || 'body');

        this.loadingIndicator = new LoadingIndicator();
        this.setupInfiniteScrolling();
    }

    setupInfiniteScrolling() {
        this.$el.find('#bts-content .container').jscroll({
            // This kinda sucks, but jscroll doesn't provide a callback to run
            // js to create loading HTML so we'll have to make our own callback
            // by inserting a script tag which calls our function.
            loadingHtml: this.loadingIndicator.getScriptTagHtml(),
            nextSelector: '.navi .js-next-link a',
            contentSelector: '.container > .item-row, .container > .navi',
            callback: () => this.loadingIndicator.removeSpinner()
        });
    }
}



/** WEBPACK FOOTER **
 ** ./js/view/BehindTheScenesHomePage.js
 **/